export interface FrameThumbProps {
  /** Resolved presigned URL, or null while it's still being fetched. */
  src: string | null;
  alt: string;
  /** Optional caption rendered under the thumb (e.g. "Captured by …"). */
  caption?: string;
  onClick: () => void;
}

export function FrameThumb({ src, alt, caption, onClick }: FrameThumbProps): JSX.Element {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <button
        type="button"
        onClick={onClick}
        style={{
          display: "block", padding: 0, border: "none", background: "#222", cursor: "pointer",
          width: 320, height: 180,
        }}
      >
        {src === null ? (
          <span
            aria-label={alt}
            style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              width: "100%", height: "100%", color: "#888", fontSize: 12,
            }}
          >
            Loading…
          </span>
        ) : src === "missing" ? (
          <span
            role="img"
            aria-label="thumbnail missing"
            style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              width: "100%", height: "100%", color: "#888", fontSize: 12,
              border: "1px dashed #555", boxSizing: "border-box",
            }}
          >
            thumbnail missing
          </span>
        ) : (
          <img src={src} alt={alt} loading="lazy" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        )}
      </button>
      {caption !== undefined && (
        <div style={{ fontSize: 12, color: "#bbb" }}>{caption}</div>
      )}
    </div>
  );
}
